import * as React from 'react';
import StartComponent from 'src/modules/commons/start/Start.component';

const AccioAccreditationComponent: React.StatelessComponent = () => (
  <section>
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-8">
          <h1 className="bold-title">
            Acreditación Acció
          </h1>
          <div className="gap-20"/>
        </div>
        <div className="col-sm-12 col-md-4">
          <p className="breadcrumb text-right">
            Inicio > Acreditación Acció
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <p>
            <strong>
              Convenio de patrocinio entre la “Agència per a la competitivitat de l’Empresa”, ACCIÓ y The Crowd Angel,
              P.F.P., S.L.
            </strong>
          </p>
          <div className="gap-20"/>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-6">
          <p>
            ACCIÓ, agencia adscrita al Departament d’Empresa i Ocupació de la Generalitat de Catalunya, tiene como
            objetivo dar soporte a la competitividad de las empresas catalanas, y centra su actividad alrededor de la
            innovación, la internacionalización, la captación de inversores, el emprendimiento, la financiación, el
            asesoramiento y la mejora de la gestión empresarial.
          </p>
          <div className="gap-20"/>
          <p>
            ACCIÓ tiene como finalidad general la promoción y el desarrollo de la empresa catalana a través de la
            ejecución de acciones y servicios de soporte necesarios para impulsar la competitividad del sector
            empresarial catalán y su presencia e interrelación con los mercados internacionales. Asimismo, tiene por
            objetivo atraer a Cataluña inversión empresarial productiva y mejoras en la productividad empresarial a
            través del fomento de la innovación y la creatividad, y el soporte al emprendimiento, favoreciendo la
            introducción de nuevas tecnologías, mejoras organizativas e instrumentos de la sociedad del conocimiento
            en el conjunto de las empresas, avanzando de esta manera hacia la diferenciación competitiva de las
            empresas catalanas.
          </p>
          <div className="gap-20"/>
        </div>
        <div className="col-sm-6 text-center">
          <img
            alt="Acció"
            src="./img/accio-edificio.png"
          />
          <div className="gap-20"/>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 text-center">
          <div className="gap-20"/>
          <img
            alt="Generalitat"
            src="./img/generalitat.png"
          />
          <div className="gap-20"/>
        </div>
      </div>
    </div>
    <StartComponent/>
  </section>
);

export default AccioAccreditationComponent;



// WEBPACK FOOTER //
// ./src/modules/accreditations/AccioAccreditation.component.tsx